import { ReportExportTypeIDs } from '@/enum/reportStatuses'

const types = {
    SET_CONF_DATA: 'SET_CONF_DATA'
}

const state = {
    confData: []
}

const mutations = {
    [types.SET_CONF_DATA]: (state, data) => {
        const newData = data
        newData.ReportExportTypeList = newData.ReportExportTypeList.filter(exportType => ReportExportTypeIDs.includes(exportType.ReportExportTypeID))

        state.confData = newData
    }
}

const actions = {
    async setConfData({ commit }, data) {
        commit(types.SET_CONF_DATA, data)
    }
}

const getters = {
    getConfData: state =>  {
        return state.confData
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
};
